import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import PageLoader from '../../../../../../components/PageLoader';
import PaymentMethodComponent from '../components/payment-method.component';
import { selectStoresListItems } from '../../../../../../redux/stores/selector';
import { stores } from '../../../../../../redux/stores/action';
import { selectPaymentMethodsQueryItems } from '../../../../../../redux/payment-methods/selector';
import { paymentMethods } from '../../../../../../redux/payment-methods/action';

const ManagementPaymentMethod = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const paymentMethodQuery = useSelector(selectPaymentMethodsQueryItems)
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const storeItems = useSelector(selectStoresListItems)
 
  const [
    chosenPaymentMethod,
    setChosenPaymentMethod
  ] = useState<any>([])

  const [
    selectRazorpay,
    setSelectRazorpay
  ] = useState<any>({

  })

  const fetchPaymentMethodQueryById= ()=>{
    dispatch(paymentMethods.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods/query-by-ids`,entity:'paymentMethods',jsonData:{
          
    RazorPayConfigurations: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerFormChange: any = (event: any, field: string, data: any) => {
    const fields = R.split(
      '.',
      field
    );
    const value = { ...data, [fields[1]]: event }// inner data update
    setChosenPaymentMethod({ ...chosenPaymentMethod, [fields[0]]: value });
    setSelectRazorpay({ ...selectRazorpay, [fields[0]]: value });
  }
  
  useEffect(
    () => {
        dispatch(stores.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`,entity:'stores',jsonData:{}
           })).then(()=>{
            if (parmas?.id > 0) {
                fetchPaymentMethodQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
          })
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setChosenPaymentMethod(paymentMethodQuery?.result?.items)
        setSelectRazorpay({ 
            CCAvenue: paymentMethodQuery?.result?.items?.RazorPayConfiguration?.CCAvenue,
            PhonePe: paymentMethodQuery?.result?.items?.RazorPayConfiguration?.PhonePe,
            RazorPay: paymentMethodQuery?.result?.items?.RazorPayConfiguration?.RazorPay})
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
    const paymentMethodData= {
            Id: chosenPaymentMethod?.Id || 0,
            RazorPayConfiguration:{
                StoreId: chosenPaymentMethod?.RazorPayConfiguration?.StoreId,
                GatewayKey:chosenPaymentMethod?.RazorPayConfiguration?.GatewayKey||'',
                GatewayName:chosenPaymentMethod?.RazorPayConfiguration?.GatewayName||'',
                GatewaySecret:chosenPaymentMethod?.RazorPayConfiguration?.GatewaySecret||'',
                IsActive:chosenPaymentMethod?.RazorPayConfiguration?.IsActive||'',
                RazorPayConfigurationPId:chosenPaymentMethod?.RazorPayConfiguration?.RazorPayConfigurationPId||'',
                RazorPay:selectRazorpay?.RazorPay || "",
                CCAvenue:selectRazorpay?.CCAvenue || "",
                PhonePe:selectRazorpay?.PhonePe || ""
            },
        
      }
   
      if (parmas?.id > 0) {
     dispatch(paymentMethods.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods`,entity:'paymentMethods',jsonData:{
          
     RazorPayConfigurations: [
        paymentMethodData
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(paymentMethods.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v2.0/configuration/payment-management/payment-methods`,entity:'paymentMethods',jsonData:{
            
        RazorPayConfigurations: [
            paymentMethodData
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/configuration/payment-management/payment-methods')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <PaymentMethodComponent 
          chosenPaymentMethod={chosenPaymentMethod}
          stores={storeItems?.result?.items}
          handleInnerFormChange={handleInnerFormChange}
           selectRazorpay={selectRazorpay}
           back={back}
           handleFormSubmit={handleFormSubmit}
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementPaymentMethod;